import React from 'react';


const Home = React.lazy(() => import('src/views/home/Home'));

const routes = [
    { path: '/', exact: true, name: 'Layaout' },
    { path: '/inicio', name: 'Inicio', component: Home }
]

export default routes
